import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { scheduleFlowsActions } from 'features/scheduleFlows';
const useScheduleFlows = () => {
  const dispatch = useDispatch();
  const getScheduleFlow = useCallback(() => dispatch(scheduleFlowsActions.getScheduleFlow()), [dispatch]);
  const createScheduleFlow = useCallback(schedule_flow => dispatch(scheduleFlowsActions.createScheduleFlow(schedule_flow)), [dispatch]);
  const updateScheduleFlow = useCallback(schedule_flow => dispatch(scheduleFlowsActions.updateScheduleFlow(schedule_flow)), [dispatch]);
  const deleteScheduleFlow = useCallback(() => dispatch(scheduleFlowsActions.deleteScheduleFlow()), [dispatch]);
  const clearLocalActiveScheduleFlow = useCallback(() => dispatch(scheduleFlowsActions.clearLocalActiveScheduleFlow()), [dispatch]);

  return {
    getScheduleFlow,
    createScheduleFlow,
    updateScheduleFlow,
    deleteScheduleFlow,
    clearLocalActiveScheduleFlow
  };
};

export default useScheduleFlows;